import { render, staticRenderFns } from "./departmentAdd.vue?vue&type=template&id=233ae1ab&scoped=true"
import script from "./departmentAdd.vue?vue&type=script&lang=js"
export * from "./departmentAdd.vue?vue&type=script&lang=js"
import style0 from "./departmentAdd.vue?vue&type=style&index=0&id=233ae1ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233ae1ab",
  null
  
)

export default component.exports